<div class="billing-info">
	<h6 class="dekra-label">DEKRA's billing information</h6>

	<div class="item">
		<nb-icon appCopyClipboard [payload]="billingData['DEKRA_ADDRESS']" icon="copy-outline"
				 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('DEKRA_ADDRESS')">
		</nb-icon>
		<div class="info-row-text">
			<p>DEKRA PAYMENT ADDRESS FOR CHECKS</p>
			<p>{{billingData['DEKRA_ADDRESS']}}</p>
		</div>
	</div>
	<div class="item">
		<nb-icon appCopyClipboard [payload]="billingData['PAYMENT_INFORMATION']" icon="copy-outline"
				 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('PAYMENT_INFORMATION')">
		</nb-icon>
		<div class="info-row-text">
			<p>DEKRA ELECTRONIC PAYMENT INFORMATION</p>
			<p>{{billingData['PAYMENT_INFORMATION']}}</p>
		</div>
	</div>
	<div class="double-items">
		<div class="item">
			<nb-icon appCopyClipboard [payload]="billingData['ACCOUNT_NUMBER']" icon="copy-outline"
					 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('ACCOUNT_NUMBER')">
			</nb-icon>
			<div class="info-row-text">
				<p>ACCOUNT NUMBER</p>
				<p>{{billingData['ACCOUNT_NUMBER']}}</p>
			</div>
		</div>
		<div class="item">
			<nb-icon appCopyClipboard [payload]="billingData['ROUTING_NUMBER']" icon="copy-outline"
					 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('ROUTING_NUMBER')">
			</nb-icon>
			<div class="info-row-text">
				<p>ROUTING NUMBER</p>
				<p>{{billingData['ROUTING_NUMBER']}}</p>
			</div>
		</div>
	</div>
	<div class="double-items">
		<div class="item">
			<nb-icon appCopyClipboard [payload]="billingData['DOMESTIC_NUMBER']" icon="copy-outline"
					 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('DOMESTIC_NUMBER')">
			</nb-icon>
			<div class="info-row-text">
				<p>DOMESTIC WIRE ROUTING NUMBER</p>
				<p>{{billingData['DOMESTIC_NUMBER']}}</p>
			</div>
		</div>
		<div class="item">
			<nb-icon appCopyClipboard [payload]="billingData['SWIFT_CODE']" icon="copy-outline"
					 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('SWIFT_CODE')">
			</nb-icon>
			<div class="info-row-text">
				<p>INTERNATIONAL SWIFT CODE</p>
				<p>{{billingData['SWIFT_CODE']}}</p>
			</div>
		</div>
	</div>
	<div class="double-items">
		<div class="item">
			<nb-icon appCopyClipboard [payload]="billingData['TAX_ID']" icon="copy-outline"
					 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('TAX_ID')">
			</nb-icon>
			<div class="info-row-text">
				<p>TAX ID NUMBER</p>
				<p>{{billingData['TAX_ID']}}</p>
			</div>
		</div>
		<div class="item">
			<nb-icon appCopyClipboard [payload]="billingData['DUNS_NUMBER']" icon="copy-outline"
					 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('DUNS_NUMBER')">
			</nb-icon>
			<div class="info-row-text">
				<p>DUNS NUMBER</p>
				<p>{{billingData['DUNS_NUMBER']}}</p>
			</div>
		</div>
	</div>
	<div class="item">
		<nb-icon appCopyClipboard [payload]="billingData['CAGE_CODE']" icon="copy-outline"
				 nbTooltip="Copied" nbTooltipPlacement="start" [nbTooltipTrigger]="noop" (click)="toggleTooltip('CAGE_CODE')">
		</nb-icon>
		<div class="info-row-text">
			<p>CAGE CODE</p>
			<p>{{billingData['CAGE_CODE']}}</p>
		</div>
	</div>
	<br>
	<div class="double-items">
		<div class="item">
			<div class="info-row-text">
				<p>BILLING CONTACT</p>
				<span class="dekra-contact"><a href="mailto: ar.na@dekra.com" target="_blank">ar.na&#64;dekra.com</a> or <a
					href="tel: 678-809-6101" target="_blank">678-809-6101</a></span>
			</div>
		</div>
		<div class="item">
			<div class="info-row-text">
				<p>CUSTOMER SERVICE CONTACT</p>
				<span><a href="mailto: clientservices@dekra.com" target="_blank">clientservices&#64;dekra.com</a> or <a
					href="tel: 215-997-4519" target="_blank">215-997-4519</a></span>
			</div>
		</div>
	</div>
</div>
